export default "/images/ccd6660ecc58590472ffe8415a43c259.avif";